////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////

import {ExportReportLocationType, FileDestinationNamingType, RevitVersion} from "../../clients/Classes";
import {Task} from "../../dataModel/Task";
import {ProjectUI} from "../../dataModel/ProjectUI";
import {DirectoryUI} from "../../dataModel/DirectoryUI";

export class OptionsState {
  exportExcel: boolean;
  includeList: boolean;
  combineReports: boolean;
  exportHtml: boolean;
  exportAvt: boolean;
  location: ExportReportLocationType;
  naming: FileDestinationNamingType;
  email: boolean;
  attachExports: boolean;
  revitVersion: RevitVersion;

  showLocationDialog: boolean = false;

  selectedProject: ProjectUI | undefined;
  selectedDirectory: DirectoryUI | undefined;

  constructor(task?: Task) {
    this.exportExcel = task?.ExportExcel ?? false;
    this.includeList = task?.ExportLists ?? false;
    this.combineReports = task?.CombineExcel ?? false;
    this.exportHtml = task?.ExportHtml ?? false;
    this.exportAvt = task?.ExportAvt ?? false;
    this.location = task?.ExportLocationType ?? ExportReportLocationType.ModelDirectory;
    this.naming = task?.ExportDestinationNaming ?? FileDestinationNamingType.AppendTimestamp;
    this.email = task?.EmailOnCompletion ?? false;
    this.attachExports = task?.AttachExportFiles ?? false;
    this.revitVersion = task?.RevitVersion ?? RevitVersion.Auto;
  }
}